<template>
  <div class="container">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadMoreList"
      v-if="list.length > 0"
    >
      <card class="list-item mb16" v-for="(item,index) in list" :key="index">
        <div class="box-top mb16">
          <div class="txt">旅行社信息待审核</div>
          <button class="btn" v-if="item.state == 1" @click="$router.push({ path: '/travelAgency/info', query: { id: item.id } })">立即处理</button>
        </div>
        <div class="tit">
          <div class="title">旅行社：</div>
          <div class="content">{{item.name}}</div>
        </div>
        <div class="tit">
          <div class="title">提交时间：</div>
          <div class="content">{{item.lastUpdateTime.substring(0,10)}}</div>
        </div>
      </card>
    </van-list>
  </div>
</template>
<script>
    import card from '../travelAgency/components/card';
    import api from '../../service/modules/travel'
    export default {
        components: {
            card
        },

        data () {
            return {
                list: [],
                pagination: { total: 0, current_page: 0, page_size: 10 },
                finished: false,
                loading: false
            };
        },

        computed: {},

        watch: {},

        methods: {
            loadMoreList () {
                this.getList();
            },
            getList () {
                api.getTodoList({ p: parseInt(this.pagination.current_page) + 1, state: 1, city: this.cityid, pageSize: 10, name: '', licenceNum: '', companyLevelStr: '', companyTypeStr: '', cityName: '', workingNum: '',statusStr:''}).then(res => {
                    if (res.ret === 0) {
                        this.pagination = res.data.pagination;
                        this.list = [...this.list, ...res.data.list];
                        this.loading = false;
                        if (
                            this.pagination.current_page >= Math.ceil(this.pagination.total / this.pagination.page_size)
                        ) {
                            this.finished = true;
                        }
                    }
                })
            }
        },

        mounted () {
            this.cityid = this.$route.query.cityid
            this.getList();
        },
        created () {
        }
    };
</script>
<style scoped lang="less">
.container {
  height: 100%;
  background-color: @base-bgcolor;
  padding: 16px 12px;
  box-sizing: border-box;
  .list-item {
    padding: 12px 16px;
    .box-top {
      height: 28px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: PingFangSC-Semibold, PingFang SC;
      .txt {
        margin-left: 0;
        font-weight: 600;
        font-size: 14px;
        color: #333333;
        line-height: 28px;
      }
      .btn {
        margin-right: 0;
        height: 28px;
        line-height: 28px;
        color: #fff;
        background: #36b374;
        padding: 0 8px;
        border: 0;
        border-radius: 2px;
        font-size: 12px;
      }
    }
    .tit {
      display: flex;
      margin-bottom: 8px;
      align-items: center;
      .title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 14px;
        display: flex;
        align-items: center;
        height: 16px;
      }
      .content {
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 260px;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
